/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { colors, LoadingSpinner } from '@blend/consumer-components';

export namespace Spinner {
  export interface Props {}
}

const styles = StyleSheet.create({
  wrapper: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
});

export const Spinner: React.FC<Spinner.Props> = () => {
  return (
    <div className={css(styles.wrapper)}>
      <span title="Loading...">
        <LoadingSpinner color={colors.catalyst} size={'lg'} />
      </span>
    </div>
  );
};
